import script from "./FileInputComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./FileInputComponent.vue?vue&type=script&setup=true&lang=js"

import "./FileInputComponent.vue?vue&type=style&index=0&id=712ecc76&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-712ecc76"]])

export default __exports__